<script>
import {mapGetters} from 'vuex'
import Creative from '../../../mixins/edit/Creative'

export default {
    name: 'creative-stacked-offer',
    mixins: [Creative],
    computed:
    {
        ...mapGetters({
            dirty: 'stackedOfferFormIsDirty'
        }),
    },
    data()
    {
        return {
            action:
            {
                update: 'stackedOfferUpdate',
                setDirty: 'stackedOfferFormDirty'
            },
            subPageName: 'stacked-offers-subpages',
            id: 'stacked_offer_id'
        }
    },
}
</script>
<template lang="html">
    <div >
        <confirm-modal @yes="save" ref="confirmModal" type="stackedOfferFormDirty"></confirm-modal>
        <div class="py-5 border-sides-1-secondary border-bottom-1-secondary" >
            <div class="px-3">
                <div class="row">
                    <div class="col-2 text-right pt-1 font-weight-bold">
                        Layout
                    </div>
                    <div class="col-3">
                        <div class="row">
                            <div class="col-12">
                                <template v-if="layouts">
                                    <custom-multiselect
                                    :selectedValue="itemLayout"
                                    labelClasses="font-weight-bold text-right pr-3"
                                    class="mb-3"
                                    :options="layouts"
                                    modelLabel="name"
                                    @selected="itemLayout = $event"
                                    ></custom-multiselect>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="col-7 text-right" v-if="false">
                        <custom-button classes="white text-desc-color xs" iconBeforeText="fas fa-eye mr-2" text="Preview" @buttonClick="preview"></custom-button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-2 text-right pt-1 font-weight-bold">
                        Primary Color
                    </div>
                    <div class="col-10">
                        <div class="row">
                            <div class="col-12 mb-2">
                                <div class="row">
                                    <div class="col-5">
                                        <color-picker v-model="item.color"></color-picker>
                                    </div>
                                    <div class="col-7">
                                        <div class="btn btn-color-preview" :style="{ backgroundColor: item.color }">
                                            <i class="fa fa-eye"></i>
                                            Can you read it ?
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-7">
                                <p>
                                    Primary color is used for headline, and sticker background.
                                    Pick a color that gives good contrast.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="px-3 border-top-1-secondary pt-4">
                <div class="row mb-1">
                    <div class="col-2 text-right pt-1 font-weight-bold">
                        Headline
                    </div>
                    <div class="col-10">
                        <simple-input
                        type="text"
                        v-model="item.headline"
                        placeholder="Type a headline"
                        noRadius
                        ></simple-input>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-2"></div>
                    <div class="col-10 text-desc-color text-sm">
                        <span v-if="item.headlines">
                            {{ 70-item.headlines.text.length }} characters left
                        </span>
                    </div>
                </div>

                <div class="row mb-1">
                    <div class="col-2 text-right pt-1 font-weight-bold">
                        Excerpts
                    </div>
                    <div class="col-10">
                        <simple-input
                        type="textarea"
                        rows="2"
                        v-model="item.excerpt"
                        placeholder="Excerpts"
                        noRadius
                        ></simple-input>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-2"></div>
                    <div class="col-10 text-desc-color text-sm">
                        <span v-if="item.excerpt">
                            {{ 200-item.excerpt.length }} characters left
                        </span>
                    </div>
                </div>

                <div class="row">
                    <div class="col-2 text-right pt-2 font-weight-bold">
                        Label Signup
                    </div>
                    <div class="col-2">
                        <div class="row mb-1">
                            <div class="col-12 mb-1">
                                <simple-input
                                type="text"
                                v-model="item.label_signup"
                                placeholder="Label Yes"
                                noRadius
                                ></simple-input>
                            </div>
                            <div v-if="item.label_signup" class="col-12 text-desc-color text-sm">
                                {{ 13-item.label_signup.length }} characters left
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="px-3 border-top-1-secondary pt-4">
                <div class="row mb-3">
                    <div class="col-2 text-right pt-1">
                        <strong>Desktop image</strong>
                         <br>
                         <i class="fas fa-info-circle"></i>
                         <span class="text-sm">720×400 px</span>
                    </div>
                    <div :class="{'mx-auto mt-2': item.desktop_images && item.desktop_images.length == 0}">
                        <template v-if="item.desktop_images && item.desktop_images.length == 0">
                            <image-uploader
                                type="desktop"
                                ref="uploader"
                                @upload-done="addDesktopImage($event)"
                                accept="image/*"
                                @dirty="setDirty"
                                @clean="setClean"
                                :width="720"
                                :height="400"></image-uploader>
                        </template>
                        <template v-else>
                            <img class="uploaded-image" v-for="image in item.desktop_images" :key="image.id" :src="image.display_url">
                            <custom-button classes="white text-desc-color xs" iconBeforeText="far fa-trash" @buttonClick="item.desktop_images = []"></custom-button>
                        </template>
                    </div>
                </div>
                <div class="row ">
                    <div class="col-2 text-right pt-1">
                        <strong>Mobile image</strong>
                         <br>
                         <i class="fas fa-info-circle"></i>
                         <span class="text-sm">670x480 px</span>
                    </div>
                    <div :class="{'mx-auto mt-2': item.mobile_images && item.mobile_images.length == 0}">
                        <template v-if="item.mobile_images && item.mobile_images.length == 0">
                            <image-uploader
                                type="mobile"
                                ref="uploader"
                                @upload-done="addMobileImage($event)"
                                accept="image/*"
                                @dirty="setDirty"
                                @clean="setClean"
                                :width="670"
                                :height="480"
                                ></image-uploader>
                        </template>
                        <template v-else>
                            <img class="uploaded-image" v-for="image in item.mobile_images" :key="image.id" :src="image.display_url">
                            <custom-button classes="white text-desc-color xs" iconBeforeText="far fa-trash" @buttonClick="item.mobile_images = []"></custom-button>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <div class="grey-bg border-bottom-1-secondary border-sides-1-secondary px-3 py-2">
            <div class="row">
                <div class="col-3">
                    <custom-button v-if="false" classes="white text-desc-color xs" iconBeforeText="fas fa-eye mr-2" text="Preview" @buttonClick="preview"></custom-button>
                </div>
                <div class="col-9 text-right">
                    <custom-button classes="white text-desc-color w-120" text="Discard" @buttonClick="discard"></custom-button>
                    <custom-button classes="blue text-white w-120" text="Save" @buttonClick="save"></custom-button>
                </div>
            </div>
        </div>
    </div>

</template>



// WEBPACK FOOTER //
// src/pages/stackedoffers/edit/Creative.vue